import { useState } from "react";
import { X, DollarSign, Smartphone, CheckCircle2 } from "lucide-react";

const fmt = (n) => `$${Number(n || 0).toFixed(2)}`;
const APPS = [
  { key: "zelle", label: "Zelle" },
  { key: "venmo", label: "Venmo" },
  { key: "paypal", label: "PayPal" },
  { key: "cashapp", label: "Cash App" },
];

export default function CheckoutModal({ total, paymentQrs, onClose, onConfirm,
  title = "Checkout", dueLabel = "Amount due", idPrefix = "sell" }) {
  const [app, setApp] = useState(null);
  const configured = APPS.filter((a) => paymentQrs?.[a.key]);
  const qrSrc = (url) => (url?.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(5,7,12,0.8)", backdropFilter: "blur(4px)" }} data-testid={`${idPrefix}-checkout-modal`}>
      <div className="w-full max-w-md rounded-2xl border overflow-hidden" style={{ background: "#0D1017", borderColor: "var(--pk-border)" }}>
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: "var(--pk-border)" }}>
          <div>
            <h3 className="font-heading text-lg font-bold text-slate-100">{title}</h3>
            <p className="text-xs text-slate-500">{dueLabel} <span className="font-mono-num text-emerald-400">{fmt(total)}</span></p>
          </div>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-200"><X className="h-5 w-5" /></button>
        </div>

        {!app ? (
          <div className="p-5 space-y-3">
            <button onClick={() => onConfirm("cash")} data-testid={`${idPrefix}-pay-cash`}
              className="w-full flex items-center justify-center gap-2 py-4 rounded-xl bg-emerald-500 text-[#04120c] font-semibold hover:bg-emerald-400">
              <DollarSign className="h-5 w-5" /> Cash
            </button>
            <div className="text-center text-xs text-slate-500">or pay electronically</div>
            {configured.length === 0 ? (
              <p className="text-xs text-amber-400/90 text-center">No payment QR codes uploaded yet. Add them in Settings → Payments.</p>
            ) : (
              <div className="grid grid-cols-2 gap-2">
                {configured.map((a) => (
                  <button key={a.key} onClick={() => setApp(a)} data-testid={`${idPrefix}-pay-${a.key}`}
                    className="flex items-center justify-center gap-2 py-3 rounded-xl border text-sm text-slate-100 hover:bg-[var(--pk-hover)]" style={{ borderColor: "var(--pk-border)" }}>
                    <Smartphone className="h-4 w-4 text-cyan-400" /> {a.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="p-5 text-center">
            <div className="text-sm text-slate-300 font-semibold mb-3">{app.label} — scan to pay {fmt(total)}</div>
            <div className="bg-white rounded-xl p-3 inline-block">
              <img src={qrSrc(paymentQrs[app.key])} alt={`${app.label} QR`} data-testid={`${idPrefix}-payment-qr`} className="w-56 h-56 object-contain" />
            </div>
            <div className="flex gap-3 mt-5">
              <button onClick={() => setApp(null)} className="flex-1 py-2.5 rounded-xl border text-sm text-slate-300 hover:bg-[var(--pk-hover)]" style={{ borderColor: "var(--pk-border)" }}>Back</button>
              <button onClick={() => onConfirm("electronic", app.key)} data-testid={`${idPrefix}-confirm-electronic`}
                className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl bg-amber-500 text-[#1a1205] font-semibold text-sm hover:bg-amber-400">
                <CheckCircle2 className="h-4 w-4" /> Payment received
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
